export default "/images/da194a5888f5f176fea799f35c6cdab8.avif";